var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbbleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F2022;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.5,250c0-44.9,11.1-86.3,33.2-124.2c22.1-38,52.1-68,90.1-90.1c38-22.1,79.4-33.2,124.2-33.2 c44.9,0,86.3,11.1,124.2,33.2c38,22.1,68,52.1,90.1,90.1c22.1,38,33.2,79.4,33.2,124.2s-11.1,86.3-33.2,124.2 c-22.1,38-52.1,68-90.1,90.1c-37.9,22.1-79.4,33.2-124.2,33.2c-44.9,0-86.3-11.1-124.2-33.2c-37.9-22.1-68-52.1-90.1-90.1 C13.6,336.3,2.5,294.9,2.5,250z M43.6,250c0,51.5,17.3,96.9,52,136.1c15.8-31,40.9-60.6,75.2-88.6c34.3-28.1,67.8-45.7,100.5-53 c-5-11.5-9.7-21.9-14.4-31.2c-56.8,18.2-118.1,27.2-184.1,27.2c-12.9,0-22.4-0.2-28.7-0.5c0,1.3-0.1,3-0.2,4.9 C43.7,247,43.6,248.7,43.6,250z M50,199c7.3,0.7,18,1,32.2,1c55.1,0,107.4-7.4,156.9-22.3c-25.1-44.6-52.6-81.7-82.7-111.4 c-26.1,13.2-48.4,31.5-67.1,54.9C70.7,144.7,57.6,170.6,50,199z M123.8,412.9c37.3,29,79.4,43.6,126.2,43.6 c24.4,0,48.7-4.6,72.8-13.9c-6.6-56.4-19.5-111-38.6-163.8c-30.4,6.6-61,23.3-91.8,50C161.5,355.4,138.6,383.5,123.8,412.9z  M199.5,50.5c29,30,55.9,67.5,80.7,112.4c44.9-18.8,78.7-42.7,101.5-71.8C343.4,59.4,299.5,43.6,250,43.6 C233.2,43.6,216.3,45.9,199.5,50.5z M298,198c4.9,10.6,10.6,23.9,16.8,40.1c24.4-2.3,51-3.5,79.7-3.5c20.5,0,40.8,0.5,60.9,1.5 c-2.6-44.9-18.8-84.8-48.5-119.8C385.5,148.4,349.2,175.6,298,198z M327.2,272.8c16.8,48.8,28.2,99,34.2,150.5 c26.1-16.8,47.4-38.4,63.9-64.8c16.5-26.4,26.4-54.9,29.7-85.6c-24.1-1.6-46-2.5-65.8-2.5C370.9,270.3,350.3,271.1,327.2,272.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbbleIcon);
export default __webpack_public_path__ + "static/media/dribbble-icon.91f1fcb1a3bd3b888fc096654af42188.svg";
export { ForwardRef as ReactComponent };